/*
 * Author: Joe Wu
 * File Created: Wednesday, 24-08-14 05:10 pm
 * Last Modified: Wednesday, 25-04-23 01:57 pm, by Roger
 */

import theme from '@ucard/ds/theme';

import { staticImgPrefix } from '@/utils/prefix';

export interface ProductConfig {
  imgSrc: string;
  bgColor: string;
  titleColor: string;
  subTitleColor: string;
  descColor: string;
  btnTextColor: string;
  btnColor: string;
  btnHoverColor: string;
  btnLink: string;
  btnCursor: string;
  i18nKey: string;
  reverse: boolean;
  vip: string;
  images: {
    src: string;
    alt: string;
  }[];
}

export const products: ProductConfig[] = [
  {
    imgSrc: staticImgPrefix('/home/home-3.webp'),
    bgColor: 'rgba(101, 45, 144, 0.50)',
    titleColor: '#7E61F3',
    subTitleColor: '#F2C89B',
    descColor: theme.palette.common.white,
    btnTextColor: '#FFFFFF',
    btnColor: '#7E61F3',
    btnHoverColor: '#7157DB',
    btnLink: '/signup',
    btnCursor: 'pointer',
    i18nKey: 'products.decard',
    reverse: true,
    vip: 'no',
    images: [
      {
        src: staticImgPrefix('/home/DeCard_VISA.png'),
        alt: 'products.decard',
      },
      {
        src: staticImgPrefix('/home/DeCard_NoScheme.png'),
        alt: 'products.decard',
      },
    ],
  },
  // {
  //   imgSrc: staticImgPrefix('/home/home-4.webp'),
  //   bgColor: '#887662',
  //   titleColor: '#EAC69F',
  //   subTitleColor: '#1e1e1e',
  //   descColor: theme.palette.common.white,
  //   btnTextColor: '#1e1e1e',
  //   btnColor: '#F2C89B',
  //   btnHoverColor: '#F2BE87',
  //   btnLink: '/luminaries',
  //   btnCursor: 'default',
  //   i18nKey: 'products.luminaries',
  //   reverse: false,
  //   vip: 'yes',
  //   images: [],
  // },
];
